<template>
  <div class="form-container">
    <!-- ローディング画面 -->
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner"></div>
      <p class="mt-2">更新中...</p>
    </div>

    <h1>測定報告書編集</h1>
    <form @submit.prevent="handleSubmit">
      <div class="mb-3">
        <label for="dear_nm" class="form-label">御中</label>
        <textarea
          v-model="measurement_report.dear_nm"
          id="dear_nm"
          class="form-control w-half"
          @keydown.shift.enter.stop 
        />
      </div>

      <div class="mb-3">
        <label for="m_bulding_id" class="form-label">建物：</label>
        {{ building.building_nm }}
        <input id="m_bulding_id" type="hidden" class="form-control w-half" :value="building.id">
      </div>

      <div class="mb-3">
        <label for="customer" class="form-label">顧客：</label>
        {{ building.m_customer?.customer_nm}}
        <input id="m_bulding_id" type="hidden" class="form-control w-half" :value="building.m_bulding_id">
      </div>

      <div class="mb-3">
        <label for="rpt_company_nm" class="form-label">報告社</label>
        <input v-model="measurement_report.rpt_company_nm" id="rpt_company_nm" type="text" placeholder="報告社" class="form-control w-half" ref="rpt_company_nm" @keydown.enter.prevent="focusNext($event)">
        <div v-if="errorMessages.report?.rpt_company_nm" class="alert alert-danger mt-2">{{ errorMessages.report?.rpt_company_nm[0] }}</div>
      </div>

      <div class="mb-1">
        <label for="rpt_company_address" class="form-label">報告社住所①</label>
        <input v-model="measurement_report.rpt_company_address" id="rpt_company_address" type="text" placeholder="報告社住所" class="form-control w-half" ref="rpt_company_address" @keydown.enter.prevent="focusNext($event)">
        <div v-if="errorMessages.report?.rpt_company_address" class="alert alert-danger mt-2">{{ errorMessages.report?.rpt_company_address[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="rpt_company_address02" class="form-label">報告社住所②</label>
        <input v-model="measurement_report.rpt_company_address02" id="rpt_company_address02" type="text" placeholder="報告社住所" class="form-control w-half" ref="rpt_company_address02" @keydown.enter.prevent="focusNext($event)">
        <div v-if="errorMessages.report?.rpt_company_address02" class="alert alert-danger mt-2">{{ errorMessages.report?.rpt_company_address02[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="regist_no" class="form-label">登録番号</label>
        <input v-model="measurement_report.regist_no" id="regist_no" type="text" placeholder="登録番号" class="form-control w-half" ref="regist_no" @keydown.enter.prevent="focusNext($event)">
        <div v-if="errorMessages.report?.regist_no" class="alert alert-danger mt-2">{{ errorMessages.report?.regist_no[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="weather" class="form-label">天候</label>
        <input v-model="measurement_report.weather" id="weather" type="text" placeholder="天候" class="form-control w-third" ref="weather" @keydown.enter.prevent="focusNext($event)">
        <div v-if="errorMessages.report?.weather" class="alert alert-danger mt-2">{{ errorMessages.report?.weather[0] }}</div>
      </div>

      <input type="hidden" v-model="measurement_report.area_point">

      <div class="mb-3">
        <label for="measure_person" class="form-label">測定者</label>
        <input v-model="measurement_report.measure_person" id="measure_person" type="text" placeholder="測定者" class="form-control w-third" ref="measure_person" @keydown.enter.prevent="focusNext($event)">
        <div v-if="errorMessages.report?.measure_person" class="alert alert-danger mt-2">{{ errorMessages.report?.measure_person[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="assistant" class="form-label">補助者</label>
        <input v-model="measurement_report.assistant" id="assistant" type="text" placeholder="補助者" class="form-control w-third" ref="assistant" @keydown.enter.prevent="focusNext($event)">
        <div v-if="errorMessages.report?.assistant" class="alert alert-danger mt-2">{{ errorMessages.report?.assistant[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="measure_dt" class="form-label">測定日 <span class="badge text-bg-danger">必須</span></label>
        <input v-model="measurement_report.measure_dt" id="measure_dt" type="date" placeholder="測定日" class="form-control w-third" required ref="measure_dt" @keydown.enter.prevent="focusNext($event)">
        <div v-if="errorMessages.report?.measure_dt" class="alert alert-danger mt-2">{{ errorMessages.report?.measure_dt[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="special_comment" class="form-label">特記事項</label>
        <textarea
          v-model="measurement_report.special_comment"
          id="special_comment"
          class="form-control" rows="4"
          @keydown.shift.enter.stop 
        />
      </div>

      <div class="mb-3">
        <!-- 測定機器選択ボックスのリスト -->
        <label for="device" class="form-label">測定機器</label>

        <table class="table table-bordered">
          <thead class="table-dark">
            <tr>
              <th>並び順<br><span class="text-danger">※報告書には表示されません</span></th>
              <th>測定種別</th>
              <th>測定機器</th>
              <th class="device-delete-btn-area"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(device, index) in selectedDevices" :key="index" class="mb-3">
              <!-- 並び順 -->
              <td><input v-model="device.sort_no" type="number" step="0.1" placeholder="並び順" class="form-control" @keydown.enter.prevent="focusNext"></td>
              <!-- 測定種別の選択 -->
              <td>
                <select class="form-select" v-model="device.m_measure_type_id" @keydown.enter.prevent="focusNext">
                  <option value="" disabled>選択してください</option>
                  <option v-for="msasureType in measureTypes" :key="msasureType.id" :value="msasureType.id">{{ msasureType.measure_type_nm }}</option>
                </select>
              </td>

              <!-- 測定機器の選択 -->
              <td>
                <select class="form-select" v-model="device.m_device_id" @keydown.enter.prevent="focusNext">
                  <option value="" disabled>選択してください</option>
                  <option v-for="device in devices" :key="device.id" :value="device.id">{{ device.device_nm }}（{{device.manufacuturer}} {{device.model_nm}} {{device.serial_no}} {{device.specification}}）</option>
                </select>

                <!-- 測定測定機器のエラーメッセージを表示 -->
                <div v-if="errorMessages.used_devices && errorMessages.used_devices[index]?.m_device_id" class="alert alert-danger mt-2">
                  {{ errorMessages.used_devices[index].m_device_id[0] }}
                </div>
              </td>
              
              <!-- 削除ボタン -->
              <td class="device-delete-btn-area">
                <button type="button" @click="removeDevice(index)" class="btn btn-danger">削除</button>
              </td>
            </tr>
          </tbody>
        </table>        

        <!-- 測定機器を追加するボタン -->
        <div class="text-center">
          <button type="button" @click="addDevice" class="btn btn-info">測定機器を追加</button>
        </div>
      </div>

      <div class="table_box mb-3">
        <table class="table table-light">
          <thead class="text-center sticky_cross">
            <tr>
              <th rowspan="4" class="text-nowrap sticky_row_thead">測定場所<br><span class="text-danger">※並び順は報告書には<br>表示されません</span></th>
              <!-- <th rowspan="4" class="text-nowrap sticky_row">回数</th> -->
              <th colspan="3" class="text-nowrap">測定状況</th>
              <th colspan="2" class="text-nowrap">温度</th>
              <th class="text-nowrap">相対湿度</th>
              <th class="text-nowrap">気流</th>
              <th colspan="2" class="text-nowrap">二酸化炭素</th>
              <th colspan="2" class="text-nowrap">一酸化炭素</th>
              <th colspan="2" class="text-nowrap">浮遊粉塵量</th>
              <th colspan="3" class="text-nowrap">その他の事項</th>
              <th rowspan="4" class="text-nowrap">備考</th>
            </tr>
            <tr>
              <th rowspan="2" class="text-nowrap">}時間</th>
              <th rowspan="2" class="text-nowrap">在室人数</th>
              <th rowspan="2" class="text-nowrap">喫煙者数</th>
              <th colspan="2" class="text-nowrap">
                {{ measureStds.filter(measure => measure.m_measure_type_id === 1 && measure.min_max_type === 0)[0]?.std_val }}〜
                {{ measureStds.filter(measure => measure.m_measure_type_id === 1 && measure.min_max_type === 1)[0]?.std_val }}℃
              </th>
              <th class="text-nowrap">
                {{ measureStds.filter(measure => measure.m_measure_type_id === 2 && measure.min_max_type === 0)[0]?.std_val }}〜
                {{ measureStds.filter(measure => measure.m_measure_type_id === 2 && measure.min_max_type === 1)[0]?.std_val }}%
                </th>
              <th rowspan="2" class="text-nowrap">{{ measureStds.filter(measure => measure.m_measure_type_id === 3 && measure.min_max_type === 1)[0]?.std_val }}m/sec以下</th>
              <th colspan="2" class="text-nowrap">{{ measureStds.filter(measure => measure.m_measure_type_id === 4 && measure.min_max_type === 1)[0]?.std_val }}ppm以下</th>
              <th colspan="2" class="text-nowrap">{{ measureStds.filter(measure => measure.m_measure_type_id === 5 && measure.min_max_type === 1)[0]?.std_val }}ppm以下</th>
              <th colspan="2" class="text-nowrap">{{ measureStds.filter(measure => measure.m_measure_type_id === 6 && measure.min_max_type === 1)[0]?.std_val }}mg/㎡以下</th>
              <th rowspan="2" class="text-nowrap">照度<br><span class="text-danger">※0で登録すると<br>ーが表示されます</span></th>
              <th rowspan="2" class="text-nowrap">騒音</th>
              <th rowspan="2" class="text-nowrap">
                <input v-model="measurement_report.other_measure_type" id="other_measure_type" type="text" placeholder="その他" class="form-control mb-0" @keydown.enter="focusNext">
              </th>
            </tr>
            <tr>
              <th class="text-nowrap">乾球</th>
              <th class="text-nowrap">湿球</th>
              <th class="text-nowrap">120cm</th>
              <th class="text-nowrap">瞬間値</th>
              <th class="text-nowrap">平均値</th>
              <th class="text-nowrap">瞬間値</th>
              <th class="text-nowrap">平均値</th>
              <th class="text-nowrap">瞬間値</th>
              <th class="text-nowrap">平均値</th>
            </tr>
            <tr>
              <th class="text-nowrap">時：分</th>
              <th class="text-nowrap">人</th>
              <th class="text-nowrap">人</th>
              <th class="text-nowrap">℃</th>
              <th class="text-nowrap">℃</th>
              <th class="text-nowrap">%</th>
              <th class="text-nowrap">m/sec</th>
              <th class="text-nowrap">ppm</th>
              <th class="text-nowrap">ppm</th>
              <th class="text-nowrap">ppm</th>
              <th class="text-nowrap">ppm</th>
              <th class="text-nowrap">mg/㎡</th>
              <th class="text-nowrap">mg/㎡</th>
              <th class="text-nowrap">Lx</th>
              <th class="text-nowrap">dB</th>
              <th class="text-nowrap">
                <input v-model="measurement_report.other_measure_unit" id="other_measure_unit" type="text" placeholder="単位" class="form-control mb-0" ref="other_measure_unit" @keydown.enter.prevent="focusNext('other_measure_unit')">
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(workPlace, wpIndex) in measurement_report.work_places">
              <tr v-for="(content, cIndex) in workPlace.t_measurement_work_place_contents" :key="cIndex" :class="{'border-bottom-bold': cIndex === 2}" class="my-3">
                <!-- 外気以外の場合 -->
                <td rowspan="3" v-if="cIndex==0 && workPlace.outside_air_flg == 0" class="sticky_row">
                  <!-- 階数とポイント -->
                  <div class="d-flex justify-content-center mb-2">
                    <!-- 階数 -->
                    <div class="mx-1">
                      <input v-model="workPlace.floor_no" placeholder="階数" class="form-control" @keydown.enter.prevent="focusNext">

                      <!-- 測定内容のエラーメッセージを表示 -->
                      <div v-if="errorMessages.work_places && errorMessages.work_places[wpIndex]?.floor_no" class="alert alert-danger mt-2">
                        {{ errorMessages.work_places[wpIndex].floor_no[0] }}
                      </div>
                    </div>

                    <!-- ポイント -->
                    <div class="mx-1">
                      <input v-model="workPlace.point_no" placeholder="ポイント" class="form-control" @keydown.enter.prevent="focusNext">

                      <!-- 測定内容のエラーメッセージを表示 -->
                      <div v-if="errorMessages.work_places && errorMessages.work_places[wpIndex]?.point_no" class="alert alert-danger mt-2">
                        {{ errorMessages.work_places[wpIndex].point_no[0] }}
                      </div>
                    </div>
                    <input v-model="workPlace.outside_air_flg" type="hidden">
                  </div>

                  <!-- 測定場所名 -->
                  <div class="mb-2">
                    <input v-model="workPlace.work_place_nm" placeholder="測定場所名" class="form-control" required @keydown.enter.prevent="focusNext">

                    <!-- 測定場所のエラーメッセージを表示 -->
                    <div v-if="errorMessages.work_places && errorMessages.work_places[wpIndex]?.work_place_nm" class="alert alert-danger mt-2">
                      {{ errorMessages.work_places[wpIndex].work_place_nm[0] }}
                    </div>
                  </div>

                  <!-- 並び順 -->
                  <div class="d-flex align-items-center justify-contente_center mb-2">
                    <label class="mb-0 me-2 text-nowrap">並び順</label>
                    <input v-model="workPlace.sort_no" type="number" step="0.1" placeholder="並び順" class="form-control" @keydown.enter.prevent="focusNext">
                  </div>

                  <!-- 削除ボタン -->
                  <button type="button" @click="removeContent(wpIndex)" class="btn btn-danger">削除</button>
                </td>

                <!-- 外気の場合 -->
                <td rowspan="3" v-if="cIndex==0 && workPlace.outside_air_flg == 1" class="sticky_row">
                  <p class=" text-start">外気</p>

                  <!-- 階数とポイント -->
                  <div class="d-flex justify-content-center mb-2 visually-hidden">
                    <!-- 階数 -->
                    <div class="mx-1">
                      <input v-model="workPlace.floor_no" placeholder="階数" class="form-control" @keydown.enter.prevent="focusNext">
                    </div>

                    <!-- ポイント -->
                    <div class="mx-1">
                      <input v-model="workPlace.point_no" placeholder="ポイント" class="form-control" @keydown.enter.prevent="focusNext">
                    </div>

                    <input v-model="workPlace.outside_air_flg" type="hidden">
                  </div>

                  <!-- 測定場所名 -->
                  <div class="mb-2">
                    <input v-model="workPlace.work_place_nm" placeholder="測定場所名" class="form-control" required @keydown.enter.prevent="focusNext">
                  </div>

                  <!-- 並び順 -->
                  <div class="d-flex align-items-center justify-contente_center mb-2">
                    <label class="mb-0 me-2 text-nowrap">並び順</label>
                    <input v-model="workPlace.sort_no" type="number" step="0.1" placeholder="並び順" class="form-control" @keydown.enter.prevent="focusNext">
                  </div>
                </td>

                <!-- 時間 -->
                <td>
                  <input 
                  :value="formatTime(content.measure_time)" 
                  @input="event => updateTime(event.target.value, wpIndex, cIndex)" 
                  type="time" 
                  class="form-control"
                  @keydown.enter.prevent="focusNext">

                  <!-- 測定内容のエラーメッセージを表示 -->
                  <div v-if="errorMessages.work_contents && errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`]?.measure_time" class="alert alert-danger mt-2">
                    {{ errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`].measure_time[0] }}
                  </div>
                </td>

                <!-- 在室人数 -->
                <td>
                  <input v-model="content.room_people_num" type="number" class="form-control" @keydown.enter.prevent="focusNext">

                  <!-- 測定内容のエラーメッセージを表示 -->
                  <div v-if="errorMessages.work_contents && errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`]?.room_people_num" class="alert alert-danger mt-2">
                    {{ errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`].room_people_num[0] }}
                  </div>
                </td>

                <!-- 喫煙者数 -->
                <td>
                  <input v-model="content.smoker_no" type="number" class="form-control" @keydown.enter.prevent="focusNext">

                  <!-- 測定内容のエラーメッセージを表示 -->
                  <div v-if="errorMessages.work_contents && errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`]?.smoker_no" class="alert alert-danger mt-2">
                    {{ errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`].smoker_no[0] }}
                  </div>
                </td>

                <!-- 乾球 -->
                <td>
                  <input
                    :value="content.dry_bulb"
                    @input="event => handleInputChange(event.target.value, content, 'dry_bulb')"
                    type="number"
                    step="0.1"
                    class="form-control"
                    @keydown.enter.prevent="focusNext"
                  >
                  <!-- 測定内容のエラーメッセージを表示 -->
                  <div v-if="errorMessages.work_contents && errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`]?.dry_bulb" class="alert alert-danger mt-2">
                    {{ errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`].dry_bulb[0] }}
                  </div>
                </td>

                <!-- 湿球 -->
                <td>
                  <input
                    :value="content.wet_bulb"
                    @input="event => handleInputChange(event.target.value, content, 'wet_bulb')"
                    type="number"
                    step="0.1"
                    class="form-control"
                    @keydown.enter.prevent="focusNext"
                  >
                  <!-- 測定内容のエラーメッセージを表示 -->
                  <div v-if="errorMessages.work_contents && errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`]?.wet_bulb" class="alert alert-danger mt-2">
                    {{ errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`].wet_bulb[0] }}
                  </div>
                </td>

                <!-- 相対湿度 -->
                <td>
                  <input v-model="content.relative_humidity" type="number" class="form-control" readonly @keydown.enter.prevent="focusNext">
                  <!-- 測定内容のエラーメッセージを表示 -->
                  <div v-if="errorMessages.work_contents && errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`]?.relative_humidity" class="alert alert-danger mt-2">
                    {{ errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`].relative_humidity[0] }}
                  </div>
                </td>

                <!-- 気流 -->
                <td>
                  <input v-model="content.air_current" type="number" step="0.01" min="0.00" class="form-control" @keydown.enter.prevent="focusNext">

                  <!-- 測定内容のエラーメッセージを表示 -->
                  <div v-if="errorMessages.work_contents && errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`]?.air_current" class="alert alert-danger mt-2">
                    {{ errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`].air_current[0] }}
                  </div>
                </td>

                <!-- 二酸化炭素瞬間値 -->
                <td>
                  <input v-model="content.co2_itt" type="number" step="10" min="0" class="form-control" @keydown.enter.prevent="focusNext">

                  <!-- 測定内容のエラーメッセージを表示 -->
                  <div v-if="errorMessages.work_contents && errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`]?.co2_itt" class="alert alert-danger mt-2">
                    {{ errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`].co2_itt[0] }}
                  </div>
                </td>

                <!-- 二酸化炭素平均値 -->
                <td rowspan="3" v-if="cIndex==0">
                  <input :value="workPlace.co2_avg" type="number" class="form-control" readonly @keydown.enter.prevent="focusNext">

                  <!-- 測定内容のエラーメッセージを表示 -->
                  <div v-if="errorMessages.work_contents && errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`]?.co2_avg" class="alert alert-danger mt-2">
                    {{ errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`].co2_avg[0] }}
                  </div>
                </td>

                <!-- 一酸化炭素瞬間値 -->
                <td>
                  <input v-model="content.co_itt" type="number" step="0.1" min="0.0" class="form-control" @keydown.enter.prevent="focusNext">

                  <!-- 測定内容のエラーメッセージを表示 -->
                  <div v-if="errorMessages.work_contents && errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`]?.co_itt" class="alert alert-danger mt-2">
                    {{ errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`].co_itt[0] }}
                  </div>
                </td>

                <!-- 一酸化炭素平均値 -->
                <td rowspan="3" v-if="cIndex==0">
                  <input v-model="workPlace.co_avg" type="number" step="0.1" class="form-control" readonly @keydown.enter.prevent="focusNext">

                  <!-- 測定内容のエラーメッセージを表示 -->
                  <div v-if="errorMessages.work_contents && errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`]?.co_avg" class="alert alert-danger mt-2">
                    {{ errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`].co_avg[0] }}
                  </div>
                </td>

                <!-- 浮遊粉塵量瞬間値 -->
                <td>
                  <input v-model="content.float_powder_dust_itt" type="number" step="0.01" min="0.00" class="form-control" @keydown.enter.prevent="focusNext">

                  <!-- 測定内容のエラーメッセージを表示 -->
                  <div v-if="errorMessages.work_contents && errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`]?.float_powder_dust_itt" class="alert alert-danger mt-2">
                    {{ errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`].float_powder_dust_itt[0] }}
                  </div>
                </td>

                <!-- 浮遊粉塵量平均値 -->
                <td rowspan="3" v-if="cIndex==0">
                  <input v-model="workPlace.float_powder_dust_avg" type="number" step="0.01" class="form-control" readonly @keydown.enter.prevent="focusNext">

                  <!-- 測定内容のエラーメッセージを表示 -->
                  <div v-if="errorMessages.work_contents && errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`]?.float_powder_dust_avg" class="alert alert-danger mt-2">
                    {{ errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`].float_powder_dust_avg[0] }}
                  </div>
                </td>

                <!-- 照度 -->
                <td>
                  <input v-model="content.illuminance" type="number" step="10" min="0" class="form-control" @keydown.enter.prevent="focusNext">

                  <!-- 測定内容のエラーメッセージを表示 -->
                  <div v-if="errorMessages.work_contents && errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`]?.illuminance" class="alert alert-danger mt-2">
                    {{ errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`].illuminance[0] }}
                  </div>
                </td>

                <!-- 騒音 -->
                <td>
                  <input v-model="content.noise" type="number" min="0" class="form-control" @keydown.enter.prevent="focusNext">

                  <!-- 測定内容のエラーメッセージを表示 -->
                  <div v-if="errorMessages.work_contents && errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`]?.noise" class="alert alert-danger mt-2">
                    {{ errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`].noise[0] }}
                  </div>
                </td>

                <!-- ホルムアルデヒド -->
                <td>
                  <input v-model="content.formaldehyde" type="number" step="0.01" min="0.00" class="form-control" @keydown.enter.prevent="focusNext">

                  <!-- 測定内容のエラーメッセージを表示 -->
                  <div v-if="errorMessages.work_contents && errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`]?.formaldehyde" class="alert alert-danger mt-2">
                    {{ errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`].formaldehyde[0] }}
                  </div>
                </td>

                <!-- 備考 -->
                <td class="remarks-area">
                  <input v-model="content.remarks" class="form-control" @keydown.enter.prevent="focusNext">

                  <!-- 測定内容のエラーメッセージを表示 -->
                  <div v-if="errorMessages.work_contents && errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`]?.remarks" class="alert alert-danger mt-2">
                    {{ errorMessages.work_contents[`[${wpIndex}, ${cIndex}]`].remarks[0] }}
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div class="text-center">
        <button type="button" @click="addWorkPlace" class="btn btn-info">測定場所を追加</button>
      </div>

      <div class="mb-3">
        <label for="internalRemarks" class="form-label">社内向け備考<span class="text-danger">※報告書には表示されません</span></label>
        <textarea
          v-model="measurement_report.internal_remarks"
          id="internalRemarks"
          class="form-control" rows="4"
          @keydown.shift.enter.stop 
        />
      </div>

      <div class="form-check mb-3">
        <label for="sign_flg" class="ECM_CheckboxInput">
          <input
            v-model="measurement_report.sign_flg"
            true-value="1"
            false-value="0"
            id="sign_flg"
            type="checkbox"
            class="ECM_CheckboxInput-Input"
          >
          <span class="ECM_CheckboxInput-DummyInput"></span>
          <h4 class="ms-3">報告書の押印欄</h4>
        </label>
      </div>

      <div class="form-check mb-3">
        <label for="book_regist_flg" class="ECM_CheckboxInput">
          <input
            v-model="measurement_report.book_regist_flg"
            true-value="1"
            false-value="0"
            id="book_regist_flg"
            type="checkbox"
            class="ECM_CheckboxInput-Input"
          >
          <span class="ECM_CheckboxInput-DummyInput"></span>
          <h4 class="ms-3">本登録チェック</h4>
        </label>
      </div>

      <div class="btn-area">
        <a class="btn btn-secondary mx-1" @click="$router.back()">戻る</a>
        <button type="submit" class="btn btn-success mx-1">更新</button>
      </div>

      <div class="btn-area-fixed">
        <a class="btn btn-secondary mx-1" @click="$router.back()">戻る</a>
        <button type="submit" class="btn btn-success mx-1">更新</button>
      </div>
    </form>
  </div>
</template>

<script>
import { ref, watch, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import { getMeasurementReport, getBuilding, getDevices, getMeasureTypes, getMeasureStds, getRelativeHumidityMatrix, updateMeasurementReport } from '@/api/axios';
import { normalizeWorkPlaceContents } from '@/utils/measurementWorkPlaceRows';

export default {
  setup() {
    const title = ref('測定報告書編集');

    watchEffect(() => {
      document.title = title.value;
    });

    const userId = ref('');
    const userName = ref('');
    const building = ref({});
    const devices = ref([]);
    const measureTypes = ref([]);
    const measureStds = ref([]);
    const selectedDevices = ref([]); // ユーザが追加する測定機器のリスト
    const measurement_report = ref({
      m_customer_id: '',
      m_building_id: '',
      measure_dt: '',
      rpt_company_nm: '',
      rpt_company_address: '',
      rpt_company_address02: '',
      regist_no: '',
      weather: '',
      area_point: '',
      measure_person: '',
      assistant: '',
      sign_title_01: '',
      sign_title_02: '',
      dear_nm: '',
      special_comment: '',
      internal_remarks: '',
      other_measure_type: '',
      other_measure_unit: '',
      sign_flg: '',
      book_regist_flg: '',
      used_devices: [], // 測定機器のIDを格納する配列
      work_places: [] // 測定場所の配列を追加
      // 他のフィールド
    });

    const errorMessages = ref({}); // エラーメッセージ用のリアクティブプロパティ
    const isLoading = ref(false);  // ローディング状態の追加

    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const mesurementReportId = route.params.id;
    const buildingId = route.params.building_id;

    // 測定機器を追加するメソッド
    const addDevice = () => {
      selectedDevices.value.push({ m_device_id: '', m_measure_type_id: '', sort_no: '' });
    };

    // 測定機器を削除するメソッド
    const removeDevice = (index) => {
      selectedDevices.value.splice(index, 1);
    };

    // 測定機器の数を監視し、変更があるたびにsort_noを更新
    watch(
      () => selectedDevices.value.length,
      () => {
        // 測定機器の並び順のナンバリングを更新
        selectedDevices.value.forEach((device, index) => {
          device.sort_no = (index + 1).toString(); // sort_noを更新
        });
      }
    );

    // 測定場所を追加するメソッド
    const addWorkPlace = () => {
      const newWorkPlace = {
        work_place_nm: '',
        floor_no: '',
        point_no: '',
        sort_no: '',
        co2_avg: '',
        co_avg: '',
        float_powder_dust_avg: '',
        outside_air_flg: 0,  // 外気ではない新しい作業場所
        t_measurement_work_place_contents: [{
                                              measure_time: '',
                                              measurement_count: 1,
                                              room_people_num: 0,
                                              smoker_no: 0,
                                              dry_bulb: '',
                                              wet_bulb: '',
                                              relative_humidity: '',
                                              air_current: '',
                                              co2_itt: '',
                                              co_itt: '',
                                              float_powder_dust_itt: '',
                                              illuminance: '',
                                              noise: '',
                                              formaldehyde: '',
                                            },
                                            {
                                              measure_time: '',
                                              measurement_count: 2,
                                              room_people_num: 0,
                                              smoker_no: 0,
                                              dry_bulb: '',
                                              wet_bulb: '',
                                              relative_humidity: '',
                                              air_current: '',
                                              co2_itt: '',
                                              co_itt: '',
                                              float_powder_dust_itt: '',
                                              illuminance: '',
                                              noise: '',
                                              formaldehyde: '',
                                            },
                                            {
                                              measure_time: '',
                                              measurement_count: 3,
                                              room_people_num: 0,
                                              smoker_no: 0,
                                              dry_bulb: '',
                                              wet_bulb: '',
                                              relative_humidity: '',
                                              air_current: '',
                                              co2_itt: '',
                                              co_itt: '',
                                              float_powder_dust_itt: '',
                                              illuminance: '',
                                              noise: '',
                                              formaldehyde: '',
                                            }]
      };

      // 外気の測定b場所のインデックスを探す
      const outsideAirIndex = measurement_report.value.work_places.findIndex(place => place.outside_air_flg);

      // 外気の測定場所が見つかった場合、その直前に新しい作業場所を挿入
      if (outsideAirIndex !== -1) {
        measurement_report.value.work_places.splice(outsideAirIndex, 0, newWorkPlace);
      } else {
        // 外気の測定場所がない場合は末尾に追加
        measurement_report.value.work_places.push(newWorkPlace);
      }
    };

    // 測定内容を削除するメソッド
    const removeContent = (wpIndex) => {
      measurement_report.value.work_places.splice(wpIndex, 1);
    };

    // 測定場所の数を監視し、変更があるたびにarea_pointを更新
    watch(
      () => measurement_report.value.work_places.length,
      () => {
        // outside_air_flgが0のものだけを数える
        const count = measurement_report.value.work_places.filter(place => place.outside_air_flg == 0).length;
        measurement_report.value.area_point = count.toString(); // area_pointは文字列として更新

        // 作業場所の並び順のナンバリングを更新
        measurement_report.value.work_places.forEach((place, index) => {
          place.sort_no = (index + 1).toString(); // sort_noを更新
        });
      }
    );

    // 相対湿度を取得
    const handleInputChange = async (value, content, field) => {
      // 入力値を適切なフィールドに設定
      content[field] = value;

      // 乾球(dry_bulb)または湿球(wet_bulb)の入力が変更されたときのみ実行
      if (field === 'dry_bulb' || field === 'wet_bulb') {
        if (content.dry_bulb && content.wet_bulb) {
          const dryWetDiff = content.dry_bulb - content.wet_bulb;
          try {
            const response = await getRelativeHumidityMatrix(dryWetDiff, content.wet_bulb);
            content.relative_humidity = response.data.relative_humidity; // 相対湿度をセット
          } catch (error) {
            console.error("APIからの相対湿度の取得に失敗しました", error);
          }
        }
      }
    };

    // 平均値計算関数を汎用化
    const calculateAverage = (workPlace, ittKey, avgKey) => {
      let sum = 0;
      let count = 0;
      workPlace.t_measurement_work_place_contents.forEach(content => {
        const value = content[ittKey];
        if (value !== null && value !== '') {
          sum += parseFloat(value);
          count++;
        }
      });

      // 空でない入力値がある場合のみ平均を計算
      const avg = count > 0 ? sum / count : '';
      workPlace[avgKey] = avg; // 平均値を設定
    };

    // work_placesの変更を監視し、変更があったら自動的に平均値を再計算
    watch(
      () => measurement_report.value.work_places, // リアクティブな参照へのアクセスを関数として提供
      (newVal) => {
        newVal.forEach((workPlace) => {
          calculateAverage(workPlace, 'co2_itt', 'co2_avg'); // 二酸化炭素の平均値計算
          calculateAverage(workPlace, 'co_itt', 'co_avg'); // 一酸化炭素の平均値計算
          calculateAverage(workPlace, 'float_powder_dust_itt', 'float_powder_dust_avg'); // 浮遊粉塵量の平均値計算
        });
      },
      { deep: true }
    );

    // ISO 8601形式の日時からHH:mm形式への変換関数
    const formatTime = (dateTimeString) => {
      if (!dateTimeString) return null;
      return dateTimeString.substring(11, 16); // 直接文字列から時間部分を抽出
    };

    // 時間更新関数
    const updateTime = (newTime, wpIndex, cIndex) => {
      if (!newTime) {
        measurement_report.value.work_places[wpIndex].t_measurement_work_place_contents[cIndex].measure_time = null;
      }else{
        const newDateTimeString = `2024-01-01T${newTime}:00.000+09:00`; // 日付は固定または適宜調整
        measurement_report.value.work_places[wpIndex].t_measurement_work_place_contents[cIndex].measure_time = newDateTimeString;
      }
    };

    // Enterキーでフォーカスを次の入力フィールドに移動するメソッド
    const focusNext = (event) => {
      const focusableElements = 'input, select, textarea';
      const focusable = Array.prototype.filter.call(
        document.querySelectorAll(focusableElements),
        function (element) {
          return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement;
        }
      );
      const index = focusable.indexOf(document.activeElement);
      if (index > -1 && (event.key === 'Enter' || event.keyCode === 13)) {
        event.preventDefault();
        focusable[index + 1].focus();
      }
    };

    const fetchReportDatas = async () => {
      userId.value = localStorage.getItem('userId');
      userName.value = localStorage.getItem('userName');
      
      try {
        const response = await getMeasurementReport(mesurementReportId);
        measurement_report.value = response.data;
        selectedDevices.value = measurement_report.value.t_measurement_used_devices;
        measurement_report.value.work_places = measurement_report.value.t_measurement_work_places;
        // 測定回数が3回未満の報告書でも列がずれないよう、明細を3行に揃える
        normalizeWorkPlaceContents(measurement_report.value.work_places);
      } catch (error) {
        console.error('測定報告書ーデータの取得に失敗しました:', error);
      }
      
      try {
        const response = await getBuilding(buildingId);
        building.value = response.data;
      } catch (error) {
        console.error('建物情報ーデータの取得に失敗しました:', error);
      }

      try {
        const response = await getDevices();
        devices.value = response.data.devices;
      } catch (error) {
        console.error('測定機器情報ーデータの取得に失敗しました:', error);
      }

      try {
        const response = await getMeasureTypes();
        measureTypes.value = response.data;
      } catch (error) {
        console.error('測定種別情報ーデータの取得に失敗しました:', error);
      }

      try {
        const response = await getMeasureStds();
        measureStds.value = response.data;
      } catch (error) {
        console.error('空気環境測定基準値情報ーデータの取得に失敗しました:', error);
      }
    };

    const handleSubmit = async () => {
      isLoading.value = true;  // ローディング開始
      try {
        measurement_report.value.m_customer_id = building.value.m_customer_id
        measurement_report.value.m_building_id = building.value.id
        measurement_report.value.user_id = userId
        measurement_report.value.used_devices = selectedDevices.value;
        await updateMeasurementReport(mesurementReportId, measurement_report.value);
        store.commit('setFlashMessage', {message: '測定報告書更新完了！', type: 'success'});
        router.push(`/measurement_reports/${mesurementReportId}`);
      } catch (error) {
        if (error.response && error.response.data) {
          // エラーメッセージをerrorMessagesにセット
          errorMessages.value = error.response.data || {};
        }
        store.commit('setFlashMessage', {message: '測定報告書更新失敗！', type: 'danger'});
        console.error('作成エラー:', error);
      } finally {
        isLoading.value = false;  // ローディング終了
      }
    };

    onMounted(() => {
      fetchReportDatas();
      // 初期値の設定
      measurement_report.value.area_point = measurement_report.value.work_places.length.toString();
    });

    return {
      title,
      userId,
      userName,
      building,
      devices,
      measureTypes,
      measureStds,
      selectedDevices,
      formatTime,
      updateTime,
      handleInputChange,
      measurement_report,
      handleSubmit,
      addDevice,
      removeDevice,
      addWorkPlace,
      removeContent,
      errorMessages,
      isLoading,
      focusNext
    };
  }
};
</script>

<style scoped>
.form-container {
  padding: 20px 20px 80px 20px;
  margin: auto;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* ローディング */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: white;
  z-index: 100;
}
.spinner {
  border: 6px solid #f3f3f3;
  border-radius: 50%;
  border-top: 6px solid #3498db;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
/* ローディング */

.table_box{
  width: 100%;
  max-height: 720px;
  min-height: 100%;
  overflow-x: auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.device-delete-btn-area{
  width: 100px;
  max-width: 100px;
  min-width: 100px;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}
th, td {
  vertical-align: middle;
  border: 1px solid #ccc !important;
  min-width: 100px;
  font-size: 14px;
  text-align: center;
}
td.remarks-area{
  min-width: 500px;
}
.sticky_row_thead,
.sticky_row {
  position: sticky;
  top: 0;
  left: 0;
  background: none;
  border-left: none;
  border-right: none;
  min-width: 200px;
}
.sticky_row_thead::before,
.sticky_row::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  z-index: -1;
}
.sticky_row_thead::before{
  background: #f2f2f2;
}
.sticky_row::before{
  background: #f2f2f2;
}

.sticky_cross {
  position: sticky;
  top: 0;
  left: 0;
  background: none;
  border-top: none;
  border-bottom: none;
  border-left: none;
  border-right: none;
  z-index: 1;
}
.sticky_cross::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  background: #212529;
  z-index: -1;
}

.border-bottom-bold{
  border-bottom: 3px solid #ccc;
}

input[type="text"],
input[type="email"],
input[type="password"] {
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.w-half{
  width: 50% !important;
}

.w-third{
  width: 30% !important;
}

.btn-area{
  margin-top: 32px;
  text-align: center;
}

.btn-area-fixed{
  position: fixed;
  top: 100px;
  right: 60px;
  z-index: 50;
}

.ECM_CheckboxInput {
  padding: 12px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.ECM_CheckboxInput h4 {
  margin-bottom: 0;
}
.ECM_CheckboxInput-Input {
  margin: 0;
  width: 0;
  opacity: 0;
}
.ECM_CheckboxInput:hover{
  background: rgba(0,0,0,.05) !important;
}
.ECM_CheckboxInput:hover > .ECM_CheckboxInput-DummyInput{
  transform: scale(1.1);
}
.ECM_CheckboxInput-Input:focus + .ECM_CheckboxInput-DummyInput{
  transform: scale(1.1);
}
.ECM_CheckboxInput-Input:checked + .ECM_CheckboxInput-DummyInput {
  background: #4d7ba7;
}
.ECM_CheckboxInput-Input:checked + .ECM_CheckboxInput-DummyInput::before {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 35%;
  height: 4px;
  border-radius: 2px;
  transform: translate(-6px, 5px) rotateZ(-135deg);
  transform-origin: 2px 2px;
  background: #FFFFFF;
}
.ECM_CheckboxInput-Input:checked + .ECM_CheckboxInput-DummyInput::after {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 70%;
  height: 4px;
  border-radius: 2px;
  transform: translate(-6px, 5px) rotateZ(-45deg);
  transform-origin: 2px 2px;
  background: #FFFFFF;
}
.ECM_CheckboxInput-DummyInput {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 32px;
  height: 32px;
  border: solid 2px transparent;
  background: rgba(0, 0, 0, .15);
  border-radius: 50%;
  transition: all .15s linear;
  }
  .ECM_CheckboxInput-LabelText {
  margin-left: 12px;
  display: block;
  font-size: 18px;
  font-weight: bold;
}
</style>
